export default {
  name: 'preloaderSpin'
};